// extracted by css-extract-rspack-plugin
export default {"body":"body--JfCSqrGHcU4X6kJp","edit":"edit--U4G_RoQ0C3cu4yTl","details":"details--kyrHSlXGcAsY3cWa"};